module.exports = __webpack_public_path__ + "media/images/icons/map/marker-ingoing-54x54-87b3decfa8d5baee165203c2d9b4f887.png";